function convertTZ(date, timeZone) {
  return new Date(
    date.toLocaleString("en-US", {
      timeZone
    })
  );
}
const convertDateTo12HourFormat = (date) => {
  let formattedOpenForAllTime = "";
  const hours = date == null ? void 0 : date.getHours();
  const minutes = date == null ? void 0 : date.getMinutes();
  const hourSession = hours >= 12 ? "PM" : "AM";
  formattedOpenForAllTime += hours % 12 || 12;
  if (minutes > 0) {
    formattedOpenForAllTime += `:${minutes}`;
  }
  formattedOpenForAllTime += hourSession;
  return formattedOpenForAllTime;
};
const zeroPad = (num) => {
  return num.toString().padStart(2, "0");
};
const getDateWithTime = (date, time) => {
  const dateWithTime = new Date(date);
  const timeArray = time.split(":");
  dateWithTime.setHours(Number(timeArray[0]));
  dateWithTime.setMinutes(Number(timeArray[1]));
  return dateWithTime;
};
const isScheduledHoursReleventForDate = (currentDate, dateToCompareAgainst, closeTime) => {
  const closingTimeDate = getDateWithTime(dateToCompareAgainst, closeTime);
  if (currentDate.getTime() < closingTimeDate.getTime()) {
    return true;
  }
  return false;
};
const getRelevantOpenHoursForDate = (currentDate, hours, holidays, searchAttempts, skippedHolidays = []) => {
  var _a, _b, _c, _d, _e, _f;
  const currentSearchAttempt = searchAttempts || 0;
  const newSkippedHolidays = [...skippedHolidays];
  const dateToCompareAgainst = new Date(currentDate);
  dateToCompareAgainst.setDate(
    dateToCompareAgainst.getDate() + currentSearchAttempt
  );
  const dateInFormat = `${dateToCompareAgainst.getFullYear()}-${zeroPad(dateToCompareAgainst.getMonth() + 1)}-${zeroPad(dateToCompareAgainst.getDate())}`;
  const holidaySchedule = holidays == null ? void 0 : holidays.find((holiday) => {
    return holiday.holidayDate === dateInFormat;
  });
  if (((_a = holidaySchedule == null ? void 0 : holidaySchedule.holidayHoursType) == null ? void 0 : _a.code) === "hours-change" && holidaySchedule.hour && isScheduledHoursReleventForDate(
    currentDate,
    dateToCompareAgainst,
    (_b = holidaySchedule.hour) == null ? void 0 : _b.close
  )) {
    return {
      close: holidaySchedule.hour.close,
      date: dateToCompareAgainst,
      open: holidaySchedule.hour.open,
      hasSpecialHours: currentSearchAttempt <= 1,
      skippedHolidays: newSkippedHolidays
    };
  }
  const isClosedForHoliday = holidaySchedule && holidaySchedule.holidayHoursType.code === "closed";
  if (!isClosedForHoliday && ((_c = holidaySchedule == null ? void 0 : holidaySchedule.holidayHoursType) == null ? void 0 : _c.code) !== "hours-change") {
    const normalSchedule = hours.find((schedule) => {
      return schedule.weekDays.includes(dateToCompareAgainst.getDay() + 1) && schedule.hoursType.code === "open";
    });
    if (normalSchedule && isScheduledHoursReleventForDate(
      currentDate,
      dateToCompareAgainst,
      normalSchedule.close
    )) {
      return {
        close: normalSchedule.close,
        date: dateToCompareAgainst,
        open: normalSchedule.open,
        hasSpecialHours: false,
        skippedHolidays: newSkippedHolidays
      };
    }
  } else if (((_d = holidaySchedule == null ? void 0 : holidaySchedule.holidayHoursType) == null ? void 0 : _d.code) === "hours-change") ;
  else {
    newSkippedHolidays.push({
      date: dateToCompareAgainst,
      reason: ((_f = (_e = holidaySchedule == null ? void 0 : holidaySchedule.name) == null ? void 0 : _e[0]) == null ? void 0 : _f.value) || "closed"
    });
  }
  if (currentSearchAttempt < 7) {
    return getRelevantOpenHoursForDate(
      currentDate,
      hours,
      holidays,
      currentSearchAttempt + 1,
      newSkippedHolidays
    );
  }
};
const getOpeningHours = (hours, timeZone, holidays) => {
  var _a;
  const openingDateObj = {
    date: null,
    isOpen: false,
    hasSpecialHours: false,
    closedForHolidayToday: { closedForHoliday: false, reason: "" }
  };
  if (hours.length) {
    const date = /* @__PURE__ */ new Date();
    const todaysDate = convertTZ(date, timeZone);
    const releventScheduleForDate = getRelevantOpenHoursForDate(
      todaysDate,
      hours,
      holidays || []
    );
    if (releventScheduleForDate) {
      const openingTimeDate = getDateWithTime(
        releventScheduleForDate.date,
        releventScheduleForDate.open
      );
      const closingTimeDate = getDateWithTime(
        releventScheduleForDate.date,
        releventScheduleForDate.close
      );
      openingDateObj.hasSpecialHours = releventScheduleForDate.hasSpecialHours;
      const todaysDateInMs = todaysDate.getTime();
      const openingTimeInMs = openingTimeDate.getTime();
      const closingTimeinMs = closingTimeDate.getTime();
      if (((_a = releventScheduleForDate.skippedHolidays) == null ? void 0 : _a.length) !== 0) {
        const eligibleSkippedHoliday = releventScheduleForDate.skippedHolidays.find(
          (holiday) => {
            return holiday.date.getDate() === todaysDate.getDate();
          }
        );
        openingDateObj.closedForHolidayToday = {
          closedForHoliday: !!eligibleSkippedHoliday,
          reason: (eligibleSkippedHoliday == null ? void 0 : eligibleSkippedHoliday.reason) || ""
        };
      }
      if (todaysDateInMs < openingTimeInMs) {
        openingDateObj.isOpen = false;
        openingDateObj.date = openingTimeDate;
      } else if (todaysDateInMs >= openingTimeInMs && todaysDateInMs < closingTimeinMs) {
        openingDateObj.isOpen = true;
        openingDateObj.date = closingTimeDate;
      }
    }
  }
  return openingDateObj;
};
const getAllOpeningHours = (hours, timeZone, holidays) => {
  const openingHoursDateObj = {
    isOpenForAll: false,
    openForAllDate: null,
    isOpenForExecutive: false,
    openForExecutiveDate: null,
    hasSpecialHours: false,
    closedForHolidayToday: { closedForHoliday: false, reason: "" }
  };
  const executiveScheduleHours = [];
  const normalScheduleHours = [];
  hours.forEach((daySchedule) => {
    var _a, _b, _c;
    if ((_c = (_b = (_a = daySchedule == null ? void 0 : daySchedule.title) == null ? void 0 : _a[0]) == null ? void 0 : _b.value) == null ? void 0 : _c.includes("Business")) {
      executiveScheduleHours.push(daySchedule);
    } else {
      normalScheduleHours.push(daySchedule);
    }
  });
  if (executiveScheduleHours.length) {
    const executiveOpeningHoursDateObj = getOpeningHours(
      executiveScheduleHours,
      timeZone,
      holidays
    );
    openingHoursDateObj.isOpenForExecutive = executiveOpeningHoursDateObj.isOpen;
    openingHoursDateObj.openForExecutiveDate = executiveOpeningHoursDateObj.date;
  }
  if (normalScheduleHours.length) {
    const normalOpeningHoursDateObj = getOpeningHours(
      normalScheduleHours,
      timeZone,
      holidays
    );
    openingHoursDateObj.isOpenForAll = normalOpeningHoursDateObj.isOpen;
    openingHoursDateObj.openForAllDate = normalOpeningHoursDateObj.date;
    openingHoursDateObj.hasSpecialHours = normalOpeningHoursDateObj.hasSpecialHours;
    openingHoursDateObj.closedForHolidayToday = normalOpeningHoursDateObj.closedForHolidayToday;
  }
  return openingHoursDateObj;
};
export {
  convertDateTo12HourFormat,
  convertTZ,
  getAllOpeningHours,
  getOpeningHours
};
